import { useEffect, useState } from 'react';
import iconUpload from '../../images/icon-upload.svg';
import axios from "axios";
import { IoIosArrowDown } from 'react-icons/io';

export default function ComEvalCheckTable({ user, fileSrc, selectEvnt, selectCompany, fileName, fileHandler, setFileName, fileRef, voltRef, memoRef, exbtPlcRef, bthNoRef, voltCodeDataList, setVoltScor, setVoltSctrGbCd }: any) {
  const [hstCmpnyNm, setHstCmpnyNm] = useState('');
  const [exbtPlcList, setExbtPlcList] = useState([]);
  const [voltCodeData, setVoltCodeData] = useState<any>({});

  useEffect(() => {
    fn_retrieveEvntDtlInfo(selectEvnt)
  }, [])
  const fn_retrieveEvntDtlInfo = async (evntSeq: number) => {
    let rtrnData = await axios.post('admin/api/evnt/retrieveEvntDtlInfo', { evntSeq: evntSeq })
    setHstCmpnyNm(rtrnData.data.hstCmpnyNm);
    rtrnData = await axios.post('admin/api/cmmn/retriveCmmnCodeList', { codeGrpId: 'A001', codes: rtrnData.data.exbtPlcs })
    setExbtPlcList(rtrnData.data);
  }

  const fn_onVoltCodeChg = async (e: any) => {
    const voltCd = e.target.value;

    const selVal = voltCodeDataList.filter((data: any) => (data.code == voltCd));
    if (selVal.length > 0) {
      console.log('selVal[0]: ', selVal[0]);
      setVoltSctrGbCd(selVal[0].sctrGbCd);
      setVoltCodeData(selVal[0]);
      setVoltScor(selVal[0].voltScor);
    } else {
      setVoltCodeData({});
      setVoltScor(0);
    }
  }

  return (
    <>
      <p className='mt-20 ml-8 text-15 leading-18 md:mt-[50px] md:ml-[5%] md:text-37 md:leading-[45px]'>상세내용</p>
      <div className='md:flex md:flex-col md:justify-center md:items-center'>
        <table className='table-fixed w-[260px] sm:w-[318px] md:w-[90%] overflow-auto mt-19 md:mt-[47px]'>
          <tbody>
            <tr className='h-36 md:h-[90px] text-[#20201D] border border-x-0 border-[#CACACA]'>
              <td colSpan={1} className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 md:leading-[37px]'>주최사</td>
              <td colSpan={4} className='align-middle pl-8 sm:pl-14 md:pl-[35px] font-preLight w-230 sm:w-260  text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px]'>{hstCmpnyNm}</td>
            </tr>
            <tr className='h-36 md:h-[90px] text-[#20201D] border border-t-0 border-x-0 border-[#CACACA]'>
              <td colSpan={1} className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 md:leading-[37px]'>업체</td>
              <td colSpan={4} className='align-middle pl-8 sm:pl-14 md:pl-[35px] font-preLight w-230 sm:w-260  text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px]'>{selectCompany.cmpnyNm}</td>
            </tr>
            <tr className='h-36 md:h-[90px] text-[#20201D] border border-t-0 border-x-0 border-[#CACACA]'>
              <td className='bg-[#F6F6F8] align-middle text-center text-13 leading-15 md:text-32 md:leading-[37px]'>업종</td>
              <td colSpan={2} className='align-middle pl-8 sm:pl-14 md:pl-[35px] font-preLight w-230 sm:w-260  text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px]'>{selectCompany.sctrGbNm}</td>
              <td className='bg-[#F6F6F8] align-middle text-center text-13 leading-15 md:text-32 md:leading-[37px]'>대표자</td>
              <td className='align-middle pl-8 sm:pl-14 md:pl-[35px] font-preLight w-230 sm:w-260 text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px]'>{selectCompany.representative}</td>
            </tr>
          </tbody>
        </table>
        <table className='table-fixed w-[260px] sm:w-[318px] md:w-[90%] overflow-auto mt-20 md:mt-[50px]'>
          <tbody>
          {user.auth !== 'KOX' &&
            <tr className='h-36 md:h-[90px] text-[#20201D] border border-x-0 border-[#CACACA]'>
              <td className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 md:leading-[37px]'>장소</td>
              <td className='md:flex md:flex-row md:justify-center md:items-center pl-8 pr-15 md:pl-[20px] md:pr-[37px] font-preLight w-230 sm:w-260 text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px]'>
                <select ref={exbtPlcRef} className='w-full h-full outline-none md:appearance-none'>
                  <option value={''}>선택</option>
                  {
                    exbtPlcList.map((exbtPlc: any) => (
                      <option key={exbtPlc.code} value={exbtPlc.code}>{exbtPlc.codeNm}</option>
                    ))
                  }
                </select>
                <IoIosArrowDown className='hidden md:block md:w-[40px] md:h-[90px]' />
              </td>
              <td className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 md:leading-[37px]'>부스번호</td>
              <td className='align-middle pl-14 pr-12 font-preLight text-14 md:text-35 leading-16 md:leading-[40px]'>
                <input type='text' ref={bthNoRef} className='w-85 md:w-[200px] text-12 sm:text-14 md:text-35 outline-none placeholder:text-12 sm:placeholder:text-14 md:placeholder:text-35 placeholder:text-[#9C9C9B] placeholder:font-preLight' placeholder='입력해주세요.' />
              </td>
            </tr>}
            <tr className='h-36 md:h-[90px] text-[#20201D] border border-x-0 border-[#CACACA]]'>
              <td className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 md:leading-[37px]'>위반내용</td>
              <td colSpan={3} className='pl-8 pr-15 md:pl-[20px] md:pr-[37px] font-preLight w-230 sm:w-260 text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px]'>
                <div className='md:flex md:flex-row md:items-center md:justify-stretch md:w-[100%]'>
                  <select ref={voltRef} onChange={fn_onVoltCodeChg} className='w-full h-full outline-none md:appearance-none'>
                    <option value="">선택</option>
                    {
                      voltCodeDataList.map((voltCodeData: any, idx: number) => {
                        return (<option key={voltCodeData.code} value={voltCodeData.code}>{voltCodeData.codeNm}</option>)
                      })
                    }
                  </select>
                  <IoIosArrowDown className='hidden md:block md:w-[40px] md:h-[90px]' />
                </div>
              </td>
            </tr>
            <tr className='h-36 md:h-[90px] text-14 md:text-35 leading-16 md:leading-[40px] border border-x-0 border-t-0 border-[#CACACA]'>
              <td className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 md:leading-[37px]'>조치</td>
              <td colSpan={3} className='align-middle pl-14 pr-12 md:pl-[35px] md:pr-[30px] font-preLight w-260 md:w-[650px] text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px]'>{voltCodeData.actGbNm}</td>
            </tr>
            <tr className='h-36 md:h-[90px] text-14 md:text-35 leading-16 md:leading-[40px] border border-x-0 border-t-0 border-[#CACACA]'>
              <td className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 md:leading-[37px]'>위반점수</td>
              <td colSpan={3} className='align-middle pl-14 pr-12 md:pl-[35px] md:pr-[30px] font-preLight w-260 md:w-[650px] text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px]'>{voltCodeData.voltScor ? voltCodeData.voltScor + '점' : null}</td>
            </tr>
            <tr className='h-107 md:h-[267px] text-14 md:text-35 leading-16 md:leading-[40px] border border-x-0 border-t-0 border-[#CACACA]'>
              <td className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 md:leading-[37px]'>메모</td>
              <td colSpan={3} className='align-top pt-12 pl-14 pr-12 md:pt-[35px] md:pl-[35px] md:pr-[30px] font-preLight w-260 md:w-[650px] text-12 sm:text-14 md:text-35 leading-16 md:leading-[40px]'>
                <textarea ref={memoRef}
                  className='w-full h-107 text-14 leading-16 md:h-[267px] md:text-35 md:leading-[40px] scrollbar-hide outline-none placeholder:text-14 md:placeholder:text-35 placeholder:text-[#9C9C9B] placeholder:leading-16 md:placeholder:leading-[40px] placeholder:font-preLight' placeholder='내용을 입력해주세요.' />
              </td>
            </tr>
            <tr className='h-107 md:h-[267px] text-14 leading-16 md:text-35 md:leading-[40px] border border-x-0 border-t-0 border-[#CACACA]'>
              <td className='bg-[#F6F6F8] align-middle text-center w-58 text-13 leading-15 md:w-[145px] md:text-32 md:leading-[37px]'>사진</td>
              <td colSpan={3} className='align-middlew-260 md:w-[650px] text-14 md:text-35 leading-16 md:leading-[40px]'>
                <div className='flex justify-center'>
                  {!fileName
                    ? <button onClick={fileHandler} className='flex justify-center items-center w-125 h-38 md:w-[312px] md:h-[95px] outline-none border border-dashed border-[#D9D9D9] rounded-[5px] md:rounded-[20px] text-14 md:text-35 text-[#C9C9C9] font-preLight'>
                      <img className='w-15 mr-12 md:w-[37px] md:mr-[30px]' src={iconUpload} alt='upload' />
                      <p>파일 올리기</p>
                    </button>
                    : <img onClick={fileHandler} src={fileSrc} alt='doneImage' className='w-full px-3 py-3 md:px-[7px] md:py-[7px] object-cover' />}
                </div>
                <input hidden onChange={(e) => setFileName(e.target.value.substring(12))} type='file' ref={fileRef} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};